import { TRecommendation } from '../recommendation';

export enum EPaginationStatus {
  Idle = 'idle',
  Loading = 'loading',
  Error = 'error',
}

export interface IRecommendationsState {
  favoriteUpdateRequestIds?: Record<number, string>;
  recommendations: TRecommendation[];
  geoRegionId?: number;
  hasMore: boolean;
  page: number;
  paginationStatus: EPaginationStatus;
  totalCount: number | null;
}
